module.exports = __webpack_public_path__ + "static/water-tower-c2c686b04a2b0ce4208264d7ff4047c7.jpg";